import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';

import { ColorCheckboxDirective } from '../../directives/color-checkbox.directive';

@Component({
  imports: [ColorCheckboxDirective, MatCheckboxModule, MatRippleModule],
  selector: 'ctr-check-option',
  templateUrl: './check-option.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: CheckOptionComponent,
      multi: true,
    },
  ],
})
export class CheckOptionComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() description = '';
  checked = false;
  onChange?: (value: boolean) => void;
  onTouched?: () => void;
  disabled = false;

  toggle(value: boolean) {
    this.checked = value;
    if (this.onChange) {
      this.onChange(value);
    }
    if (this.onTouched) {
      this.onTouched();
    }
  }

  writeValue(value: boolean): void {
    this.checked = value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
